import { Drawer as BaseDrawer } from 'antd';
import React, {
  forwardRef,
  type PropsWithChildren,
  useImperativeHandle,
  useRef,
} from 'react';
import styled from 'styled-components';

const Drawer = styled(BaseDrawer)`
  .ant-drawer-body {
    padding: 0;
  }

  .ant-drawer-header {
    height: 65px;
  }

  .ant-drawer-close {
    height: 100%;
    padding-top: 4px;
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CREATIVE_DRAWER_LAYOUT_WIDTH = 720;

export interface DrawerLayoutController {
  scrollToBottom: () => void;
}

export type DrawerLayoutProps = PropsWithChildren<{
  onClose?: () => void;
  open?: boolean;
  title: string | React.ReactNode;
}>;

const DRAWER_CLASSNAME = 'ant-drawer-body';
function doScrollToBottom(bodyDiv: HTMLDivElement | null | undefined) {
  const drawerBody = bodyDiv?.parentElement;
  if (drawerBody) {
    if (drawerBody.classList.contains(DRAWER_CLASSNAME)) {
      setTimeout(() => drawerBody.scrollTo(0, drawerBody.scrollHeight), 0);
    } else {
      console.warn(
        `DrawerLayout#doScrollToBottom: Check antd <Drawer>:` +
          ` ${DRAWER_CLASSNAME} not present in classList ${drawerBody.classList}`
      );
    }
  }
}

// Note: forwardRef is deprecated in React 19 (when we get there)
const DrawerLayout = forwardRef<DrawerLayoutController, DrawerLayoutProps>(
  function DrawerLayout({ onClose, title, open, children }, ref) {
    const bodyRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => {
      return {
        scrollToBottom() {
          doScrollToBottom(bodyRef.current);
        },
      };
    }, []);

    return (
      <Drawer
        onClose={onClose}
        mask={false}
        title={title}
        open={open}
        closable={{ placement: 'end' }}
        width={CREATIVE_DRAWER_LAYOUT_WIDTH}
      >
        <Body ref={bodyRef}>{children}</Body>
      </Drawer>
    );
  }
);

export default DrawerLayout;
